import axios from "axios";
import type { AxiosResponse } from "axios";

export function cancelSubscription(
  email: string,
  subscriptionId: string
): Promise<AxiosResponse> {
  return axios.post("/.netlify/functions/cancel-subscription", {
    email,
    subscriptionId
  });
}
